import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAccountId } from "../utils";
import { useCurrentAccount } from "./useCurrentAccount";
export var useProtectUnpublishedProduct = function(data) {
    var navigate = useNavigate();
    useEffect(function() {
        if (!data) return;
        var isLive = data.isLive, isPublic = data.isPublic, owner = data.owner;
        if (!(isLive && isPublic) && owner !== getAccountId()) {
            navigate("/");
        }
    }, [
        data,
        navigate
    ]);
};
export var useProtectManageProduct = function(data) {
    var canPublishProducts = useCurrentAccount().canPublishProducts;
    var navigate = useNavigate();
    useEffect(function() {
        if (!data) return;
        var owner = data.owner;
        if (canPublishProducts === false || owner !== getAccountId()) {
            navigate("/");
        }
    }, [
        data,
        canPublishProducts,
        navigate
    ]);
};

//# sourceMappingURL=useProtectProduct.js.map